export default "__VITE_ASSET__PrHQBTcQ__"